function Project(name) {
    const todos = [];

    return {
        name,
        todos
    };
}

export { Project };